// extracted by mini-css-extract-plugin
module.exports = {"root":"WithSidebar_root__KU48D","content":"WithSidebar_content__tcgh9","sidebar":"WithSidebar_sidebar__1QHru"};